export var Distribution;
(function (Distribution) {
    Distribution["AppStore"] = "AppStore";
    Distribution["PlayStore"] = "PlayStore";
    Distribution["AppStorePremium"] = "AppStorePremium";
    Distribution["PlayStorePremium"] = "PlayStorePremium";
})(Distribution || (Distribution = {}));
